import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "es",
  setLang: () => {},
  t: translations.es,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem("vexly_lang");
      if (saved === "en" || saved === "es") return saved;
    } catch (_) {}
    return "es";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem("vexly_lang", next);
    } catch (_) {}
  }, []);

  // Sync <html lang="..."> with current language for SEO/accessibility
  React.useEffect(() => {
    try {
      document.documentElement.lang = lang;
    } catch (_) {}
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: translations[lang],
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
